function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_621",
  "data-name": "Gruppe 621",
  transform: "translate(-392 -407.999)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_316",
  "data-name": "Gruppe 316",
  transform: "translate(392 427.396)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon_39",
  "data-name": "Polygon 39",
  d: "M57.631,0l57.631,98.8H0Z",
  transform: "translate(115.263 98.797) rotate(180)",
  opacity: 0.102
}), /*#__PURE__*/React.createElement("path", {
  id: "Polygon_58",
  "data-name": "Polygon 58",
  d: "M28.755,0,57.51,49.165H0Z",
  transform: "translate(57.753 49.632)",
  opacity: 0.197
})), /*#__PURE__*/React.createElement("g", {
  id: "fill_in_data",
  transform: "translate(447.211 403.199)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1105",
  "data-name": "Pfad 1105",
  d: "M53.354,31.221a1.783,1.783,0,0,1-1.375-.589L35.289,14.138a1.944,1.944,0,0,1,2.749-2.749l16.69,16.69a1.9,1.9,0,0,1,0,2.749A3.64,3.64,0,0,1,53.354,31.221Z",
  transform: "translate(24.957 5.782)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1106",
  "data-name": "Pfad 1106",
  d: "M10.864,87.663a1.783,1.783,0,0,1-1.375-.589A2.741,2.741,0,0,1,8.9,85.307l5.105-22.778a1.08,1.08,0,0,1,.589-.982L70.949,5.389a1.9,1.9,0,0,1,2.749,0L91.371,23.061a1.9,1.9,0,0,1,0,2.749L35.016,82.165a4.293,4.293,0,0,1-.982.589L11.256,87.663ZM17.736,64.1l-4.32,19.047,19.047-4.32L87.051,24.24,72.127,9.316Z",
  transform: "translate(0.096 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1107",
  "data-name": "Pfad 1107",
  d: "M31.136,55a1.783,1.783,0,0,1-1.375-.589L12.089,36.738a1.944,1.944,0,0,1,2.749-2.749L32.51,51.661a1.9,1.9,0,0,1,0,2.749A2.121,2.121,0,0,1,31.136,55Z",
  transform: "translate(2.602 27.559)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1108",
  "data-name": "Pfad 1108",
  d: "M90.093,52.727H10.764a1.964,1.964,0,1,1,0-3.927H89.9a1.855,1.855,0,0,1,1.964,1.964A1.813,1.813,0,0,1,90.093,52.727Z",
  transform: "translate(0 42.398)"
})));

var SvgIntroFill = function SvgIntroFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147.267,
    height: 118.194,
    viewBox: "0 0 147.267 118.194",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntroFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/intro_fill.a6681788.svg";
export { ForwardRef as ReactComponent };